const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.citycourier.org/api/v1';

export interface LoginCredentials {
	email?: string;
	loginID?: string;
	password: string;
}

// Helper function to determine if input is email
export const isEmail = (input: string): boolean => {
	return /\S+@\S+\.\S+/.test(input);
};

export interface RegisterData {
	// Business Information
	area: string;
	pointOfSale: string;
	accountType: string;
	businessProfile: string;
	
	// Client Information
	fullName: string;
	companyName: string;
	completeAddress: string;
	authorizePersonName: string;
	authorizePersonDesignation: string;
	authorizePersonPhone: string;
	authorizePersonCNIC: string;
	adminContactName: string;
	adminPhoneNumber: string;
	financeContactName: string;
	webAddress: string;
	brandName: string;
	ntnCNIC: string;
	gst: string;
	businessSector: string;
	products: string;
	
	// Bank Details
	bankAccountTitle: string;
	bankName: string;
	bankIBAN: string;
	bankCodeAccountNumber: string;
	
	// Operation Information
	pickupAddress: string;
	contactPerson: string;
	phoneNumber: string;
	emailAddress: string;
	
	// Login Information
	password: string;
	confirmPassword: string;
	termsAccepted: boolean;
}

export interface AuthResponse {
	user: {
		id: number;
		loginID: string;
		email: string;
		name: string;
		type: 'ADMIN' | 'MANAGER';
		status: number;
		created_at: string;
		profile?: {
			id: number;
			user_id: number;
			phone?: string;
			phone2?: string;
			cnic?: string;
			address?: string;
			city_id?: number;
			city?: {
				id: number;
				name: string;
			};
		};
	};
	token: string;
}

export const authApi = {
	login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
		const response = await fetch(`${API_BASE_URL}/auth/login`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(credentials),
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			throw new Error(errorData.message || 'Login failed');
		}

		const data = await response.json();
		return data.data;
	},

	register: async (data: RegisterData): Promise<AuthResponse> => {
		const response = await fetch(`${API_BASE_URL}/clients/register`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			throw new Error(errorData.message || 'Registration failed');
		}

		const responseData = await response.json();
		return responseData.data;
	},

	verifyToken: async (token: string): Promise<AuthResponse> => {
		const response = await fetch(`${API_BASE_URL}/auth/verify`, {
			method: 'GET',
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			throw new Error(errorData.message || 'Token verification failed');
		}

		const data = await response.json();
		return data.data;
	},
}; 